import { render, staticRenderFns } from "./Color_styles.vue?vue&type=template&id=92ac0118&scoped=true"
import script from "./Color_styles.vue?vue&type=script&lang=js"
export * from "./Color_styles.vue?vue&type=script&lang=js"
import style0 from "./Color_styles.vue?vue&type=style&index=0&id=92ac0118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ac0118",
  null
  
)

export default component.exports